// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"41737":"doppe-viewer-wix-web-bi-logger","49533":"doppe-viewer-bm-analytics-dashboard-bi-logger","51800":"doppe-action-type-auto-blog-post-widget","85092":"doppe-viewer-api-routes-manager","87901":"doppe-action-type-articles-list-widget"}[chunkId] || chunkId) + ".bundle.js";
};